import {
  BackgroundColorInterface,
  BackgroundImageInterface,
  BackgroundStylesInterface,
} from 'common/types/background-interfaces'
import {
  BorderType,
  ContentWidthEnum,
  PaddingType,
} from 'common/types/styleTypes'
import React, { ReactNode } from 'react'
import { WebsiteFooterBackgroundUi } from './ui/website-footer-background-ui'
import { WebsiteFooterWrapper } from './ui/website-footer-wrapper'

export interface CommonWebsiteFooterProps
  extends BackgroundColorInterface,
    BackgroundImageInterface {
  htmlAttrId: string
  children: ReactNode
  background?: BackgroundStylesInterface
  border: Partial<BorderType>
  mobileBorder: Partial<BorderType>
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  contentWidth?: ContentWidthEnum
}

export const CommonWebsiteFooter = ({
  htmlAttrId,
  children,
  background,
  backgroundImage,
  backgroundColor,
  ...rest
}: CommonWebsiteFooterProps) => (
  <WebsiteFooterBackgroundUi
    background={background}
    backgroundImage={backgroundImage}
    backgroundColor={backgroundColor}
  >
    <WebsiteFooterWrapper {...rest} id={htmlAttrId}>
      {children}
    </WebsiteFooterWrapper>
  </WebsiteFooterBackgroundUi>
)
